import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBranchDocument = id => {
  return http.get(
    `${getBaseUrl()}/branch_document/${id}`
  );
};

export const getBranchDocuments = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/branch_document`
    );
  }
  return http.get(
    `${getBaseUrl()}/branch_document?${paginate}`
  );
};

export const getBranchDocumentsByBranchId = (data) => {
  return http.get(
    `${getBaseUrl()}/branch_document/${data}`
  );
};

export const updateBranchDocument = data => {

  return http.put(
    `${getBaseUrl()}/branch_document/${data.id}`,
    data
  );
};
export const submitBranchDocument = data => {

  return http.post(
    `${getBaseUrl()}/branch_document`,
    data
  );
};
